import Image from 'next/legacy/image';

import { H2, H3, H5 } from '@common/headline';

import Blob1 from '@public/img/nhs/published-data-blob-1.svg';
import Blob2 from '@public/img/story/description-blob-2.svg';
import bmj from '@public/img/nhs/the-bmj-logo.png';
import obesityJournal from '@public/img/nhs/obesity-journal.jpg';

export const PublishedData = (): JSX.Element => {
  const bodyText = (
    <span className="p-8 text-mono-white">
      <div className="mb-4">
        <H3>
          We{"'"}re at the forefront of research into remotely delivered weight
          management, diabetes prevention, and type 2 diabetes management
          services
        </H3>
      </div>
      <H5>
        Our outcomes are{' '}
        <span className="text-salmon">published in 13 studies</span> across the
        British Medical Journal, Obesity, Diabetic Medicine, Journal of Medical
        Internet Research, Advanced Technologies &amp; Treatments for Diabetes
        and Future of Healthcare Journal.
      </H5>
    </span>
  );
  return (
    <div className="relative w-full bg-blue p-4">
      <div className="absolute left-0 top-0 z-10 hidden lg:block">
        <Image src={Blob1} width={220} height={320} />
      </div>
      <div className="absolute bottom-0 right-0 z-10">
        <Image src={Blob2} width={471} height={315} />
      </div>
      <div className="container relative z-20 mx-auto px-4 py-16 text-mono-white lg:p-[75px]">
        <div className="mb-6">
          <H2>
            Published <span className="text-salmon">data</span>
          </H2>
        </div>
        <div className="mb-12 lg:hidden">
          <H5>{bodyText}</H5>
        </div>
        <div className="mb-12 hidden lg:block">
          <H3>{bodyText}</H3>
        </div>
        <div>
          <div style={{ marginRight: '1rem', display: 'inline-block' }}>
            <a
              href="https://drc.bmj.com/content/10/3/e002736"
              target="_blank"
              rel="noreferrer"
            >
              <Image src={bmj} alt="bmj" width={100} height={65} />
            </a>
          </div>
          <div style={{ display: 'inline-block' }}>
            <a
              href="https://onlinelibrary.wiley.com/doi/10.1002/oby.24024"
              target="_blank"
              rel="noreferrer"
            >
              <Image
                src={obesityJournal}
                alt="obesity"
                width={575}
                height={65}
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
